exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.new_landing-tabs[data-v-0232ffef]{\n  padding: 12px;\n}\n", ""]);

// exports
